import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IShop } from '@app/common';
import { rootApi, rootMiddleware, TagTypes, tagTypes } from '../api';

type State = {
  selectedShop?: IShop;
}

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    selectedShop: undefined,
  } as State,
  reducers: {
    setSelectedShop(state, action: PayloadAction<IShop | undefined>) {
      state.selectedShop = action.payload;
    },
  },
});

rootMiddleware.startListening({
  matcher: appSlice.actions.setSelectedShop.match,
  effect: async (_, api) => {
    api.dispatch(rootApi.util.invalidateTags(tagTypes as unknown as TagTypes[]));
  },
});